<template>
  <div>

    <!-- <div class="bdg2" v-if="isPc === 0">
        <div class="btns">
            <div class="btn apple" @click="redirectAppleStore"></div>
            <div class="btn google" @click="redirectGooglePlay"></div>
        </div>
    </div> -->
    <div class="download">
        <div class="d-flex align-items-start flex-column gap-16 m-top-1rem m-bottom-1rem">
            <img src="../../assets/1a.png" class="logo object-fit-contain" alt="">
            <div class="form">
                <div class="form__container">
                    <div class="form__container--content">
                        <div class="form__container--content__item">
                            <div class="input">
                                <label>Mobile number</label>
                                <el-input :maxlength="max" :disable="disableNumber"  v-model="form.number" @input="detectInput" class="peiso-input-default mobile-number" :readonly="true"></el-input>
                            </div>
                        </div>
                        <div  class="form__container--content__item">
                            <div class="input">
                                <label>Passcode</label>
                                <el-input type="text" :maxlength="4"  v-model="form.passcode" @input="detectPasscode" class="peiso-input-default passcode"></el-input>
                            </div>
                        </div>
                        <div  class="form__container--content__item">
                            <div class="input">
                                <label>Confirm Passcode</label>
                                <el-input type="text" :maxlength="4"  v-model="form.confirm_passcode" @input="detectConfirmPasscode" class="peiso-input-default passcode"></el-input>
                            </div>
                        </div>
                        <div>
                            <el-button type="peiso-primary-pink button-passcode" @click="setPasscode" >Set Passcode</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="download__btns">
                <div class="download__btns--item" @click="redirectAppleStore">
                    <img src="../../assets/1b.png" alt="">
                </div>
                <div class="download__btns--item" @click="redirectGooglePlay">
                    <img src="../../assets/1c.png" alt="">
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="bdg2">
        <div class="form">
            <div class="form__container">
                <div class="form__container--content">
                    <div class="form__container--content__item">
                        <div class="input">
                            <label>Mobile number</label>
                            <el-input :maxlength="max"  v-model="form.number" @input="detectInput" class="peiso-input-default mobile-number"></el-input>
                        </div>
                    </div>
                    <div  class="form__container--content__item">
                        <div class="input">
                            <label>Passcode</label>
                            <el-input type="password" :maxlength="4"  v-model="form.passcode" @input="detectPasscode" class="peiso-input-default passcode"></el-input>
                        </div>
                    </div>
                    <div  class="form__container--content__item">
                        <div class="input">
                            <label>Confirm Passcode</label>
                            <el-input type="password" :maxlength="4"  v-model="form.confirm_passcode" @input="detectConfirmPasscode" class="peiso-input-default passcode"></el-input>
                        </div>
                    </div>
                    <div>
                        <el-button type="peiso-primary-pink button-passcode" @click="setPasscode" >Set Passcode</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns">
            <div class="btn apple" @click="redirectAppleStore"></div>
            <div class="btn google" @click="redirectGooglePlay"></div>
        </div>
    </div> -->

  </div>
</template>

<script>
import CallApp from 'callapp-lib';
import utils from '@/utils/utils';
import login from '@/api/login';
export default {
  name: 'download',
  data () {
    return {
        input: '',
        isPc: 2,
        max: 9,
        disableNumber: false,
        form: {
            number: '',
            passcode: '',
            confirm_passcode: ''
        }
    }
  },
  created() {
    // let u = navigator.userAgent
    // if (!!u.match(/ctible/i) || u.match(/Windows/i)) {
    //     this.isPc = 1
    // } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
    //     this.isPc = 1
    // }  else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
    //     this.isPc = 0
    // } else if (!!u.match(/android/i)) {
    //     this.isPc = 0
    // } else {
    //     this.isPc = 1
    // }

    // let number = location.search && location.search.indexOf('?phonenumber=') !== -1 ? location.search.split('?phonenumber=')[1] : ''
    let number = this.$route.query.phonenumber
    if (number) {
        this.form.number = number;
        this.disableNumber = true;
    }

    // this.jump()
  },
  methods: {
    detectInput () {
        this.form.number = this.form.number.replace(/[^\d]/g, '')
        this.max = 10
    },

    setPasscode() {
        // save data
        if (this.form.number == '') {
            utils.alert2('', 'Mobile number is required.', 'error');
            return;
        }

        if (this.form.passcode == '') {
            utils.alert2('', 'Passcode is required.', 'error');
            return;
        }

        if (this.form.confirm_passcode == '') {
            utils.alert2('', 'Confirm Passcode is required.', 'error');
            return;
        }

        if (this.form.passcode !== this.form.confirm_passcode) {
            utils.alert2('', 'The passcode does not match the confirm passcode.', 'error');
            return;
        }

        var payload = {
            mobileNumber: this.form.number,
            password: this.form.passcode
        }

        login.userPasswordSet(payload).then((res) => {

            var data = res.data 


            if (data.code == 0) {
                utils.alert2('', 'Passcode successfully set. You can now login your account to your Peiso App', 'success', 6000)
            } else {
                utils.alert2('', 'You already set your account passcode. Please login now to your Peiso App.', 'error', 6000)
            }

            this.form.passcode = ''
            this.form.confirm_passcode = ''
        })

        // API RESPONSE

    },
    detectPasscode () {
        this.form.passcode = this.form.passcode.replace(/[^\d]/g, '')
    },
    detectConfirmPasscode () {
        this.form.confirm_passcode = this.form.confirm_passcode.replace(/[^\d]/g, '')
    },
    redirectAppleStore ()  {
        window.location = process.env.APPLE_STORE
    },
    redirectGooglePlay () {
        window.location = process.env.GOOGLE_STORE
    },
    jump() {
        let u = navigator.userAgent
        let isAndroid = /android/i.test(u)
        let param = location.search && location.search.indexOf('?phonenumber=') !== -1 ? location.search.split('?phonenumber=')[1] : ''
        if(param){
            const callLib = new CallApp({
                scheme:{
                    protocol:'peiso',
                    host:'venue.peiso.com.au',
                },
                intent: {
                    package: 'user.peiso.com.au',
                    scheme: 'peiso'
                },
                timeout:5000,
                appstore:''
            });
            callLib.open({
                param: {
                    phonenumber: param
                },
                path: 'venuePeiso',
                callback:()=>{
                    // 唤起失败处理
                    // history.push('/share')
                    if (isAndroid)
                        window.location = `peiso://venue.peiso.com.au?phonenumber=${param}`
                }
            });
        }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'static/scss/media-queries';
.download {
    width: 100%;
    height: 100vh;
    overflow: auto;
    background-color: #EA3796;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //gap: 30px;
    gap: 10rem;
    &__btns {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
        align-items: center;
        &--item {
            cursor: pointer;
            width: 250px;
            img {
                width: 100%;
            }
        }
    }

    @include height-resolution(766px) {
        height: auto;
    }

    .logo {
        @include mobile-lg {
            height: 40px;
        }
    }
}
.form {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    margin-bottom: 50px;
    // display: none;
    //remmove display none
    &__container {
        width: 350px;
        border-radius: 10px;
        padding: 25px;
        background-color: #434968;
        color: var(--text-color);
        &--content {

            &__item {
                text-align: center;
                margin-bottom: 10px;
                label {
                    font-size: 15px;
                    font-weight: 600;
                    color: var(--text-color);
                    text-align: center;
                    margin-bottom: 10px
                }
            }
        }
    }
}

.bdg2{
    width: 100%;
    height: 100vh;
    background-color: #EA3796;
    background-repeat: no-repeat;
    background-size: 76% auto;
    background-position: center 25%;
    background-image: url('../../assets/1a.png');
    max-width: 1000px;
    min-height: 500px;
    position: relative;
    margin: 0 auto;
    .btns{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }
    .btn{
        width: 62.9%;
        margin: 0 auto;
        padding-bottom: 18.6%;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        margin-bottom: 3.5%; 
        &:nth-last-child(1){
            margin-bottom: 11%; 
        }
        &.apple{
            background-image: url('../../assets/1b.png');   
        }
        &.google{
            background-image: url('../../assets/1c.png');   
        }
    }
}
.bdg3{
    width: 100%;
    height: 100vh;
    background-color: #EA3796;
    background-repeat: no-repeat;
    background-size: 180px auto;
    background-position: center 180px;
    background-image: url('../../assets/1a.png');
    min-width: 700px;
    min-height: 500px;
    box-sizing: border-box;
    padding-top: 250px;
    .btns{
        width: 500px;
        margin: 0 auto;
    }
    .btn{
        width: 240px;
        height: 70px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        cursor: pointer;
        &.apple{
            float: left;
            background-image: url('../../assets/1b.png');   
        }
        &.google{
            float: right;
            background-image: url('../../assets/1c.png');   
        }
    }

}

</style>



// WEBPACK FOOTER //
// src/components/login/download.vue